export type LetterSenderAccept = Record<string, string[]>;

export type LetterSenderProviderConfig = {
  accept?: LetterSenderAccept;
  maxFiles?: number;
  maxSize?: number;
  maxCombinedFileSize?: number;
};

const MiB = 1024 * 1024;

export const LETTER_SENDER_PROVIDER_CONFIG: Record<string, LetterSenderProviderConfig> = {
  HealthLink: {
    accept: {
      'application/pdf': ['.pdf'], // Same as backend.
    },
    maxFiles: 5, // Arbitrary limit.
    maxSize: 3 * MiB, // Same as backend.
    maxCombinedFileSize: 3 * MiB, // Same as backend.
  },
  Email: {
    accept: {
      'application/pdf': ['.pdf'],
    },
    maxFiles: 5,
    maxSize: 4 * MiB,
    maxCombinedFileSize: 20 * MiB,
  },
};

export const LetterSenderProviders = Object.keys(LETTER_SENDER_PROVIDER_CONFIG);
